
export enum ClusterNodeStatus {
    UNACCEPTED ='Node Unaccepted',
	AVAILABLE = 'Available',
	UNAVAILABLE ='Unavailable',
	PROVISIONING = 'Provisioning'
}
